import { render, staticRenderFns } from "./topic-edit.component.vue?vue&type=template&id=a23ee6ae&scoped=true"
import script from "./topic-edit.component.vue?vue&type=script&lang=ts"
export * from "./topic-edit.component.vue?vue&type=script&lang=ts"
import style0 from "./topic.style.scss?vue&type=style&index=0&id=a23ee6ae&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23ee6ae",
  null
  
)

export default component.exports